import * as ST from './styled';
var ChannelsList = function (_a) {
    var _b = _a.channels, channels = _b === void 0 ? [] : _b, channelsFiltersIsApply = _a.channelsFiltersIsApply, _c = _a.inactiveLink, inactiveLink = _c === void 0 ? false : _c;
    return (<ST.Wrapper data-test='channels-list'>
            {channelsFiltersIsApply && !channels.length && (<ST.ChannelText data-test='channels-list-notfound-msg'>
                        Канал, который вы ищете, не входит в данный тариф
                    </ST.ChannelText>)}
            <ST.List>
                {channels.map(function (channel) {
            return <ST.ChannelWithMargin key={channel.channelId} link={channel.channelInfo.url} image={channel.channelInfo.logo} title={channel.title} inactiveLink={inactiveLink} data-test='channels-list-channels'/>;
        })}
            </ST.List>
        </ST.Wrapper>);
};
export default ChannelsList;
